export interface GastronomyItem {
  id: string;
  image: string;
  isReverse?: boolean; // per alternare il layout
}

export const gastronomyItems: GastronomyItem[] = [
  {
    id: 'olive_oil',
    image: '/curiosities/gastronomy/olive_oil.webp',
    isReverse: false
  },
  {
    id: 'genziana',
    image: '/curiosities/gastronomy/genziana.webp',
    isReverse: true
  },
  {
    id: 'wine',
    image: '/curiosities/gastronomy/wine.webp',
    isReverse: false
  },
  {
    id: 'arrosticini',
    image: '/curiosities/gastronomy/arrosticini.webp',
    isReverse: true
  },
  {
    id: 'cheese',
    image: '/curiosities/gastronomy/cheese.webp',
    isReverse: false
  }
];
